import React, { useState, useEffect } from 'react';
import { Building2, ChevronLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../services/supabase';
import { useAuth } from '../../contexts/AuthContext';

const BusinessList = () => {
  const [businesses, setBusinesses] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    fetchBusinesses();
  }, []);

  const fetchBusinesses = async () => {
    try {
      const { data, error } = await supabase
        .from('businesses')
        .select('*')
        .eq('owner_id', user.id);

      if (error) throw error;
      setBusinesses(data || []);
    } catch (err) {
      console.error('Error fetching businesses:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 p-4">
        <div className="animate-pulse space-y-4">
          <div className="h-8 bg-gray-200 rounded w-1/3"></div>
          <div className="h-24 bg-gray-200 rounded"></div>
          <div className="h-24 bg-gray-200 rounded"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="sticky top-0 bg-white border-b">
        <div className="flex items-center p-4">
          <button 
            className="mr-4"
            onClick={() => navigate(-1)}
          >
            <ChevronLeft className="w-6 h-6" />
          </button>
          <h1 className="text-xl font-bold flex-1">Tu Negocio</h1>
        </div>
      </div>

      <div className="p-4 space-y-4">
        {businesses.length === 0 ? (
          <div className="text-center py-8">
            <Building2 className="w-12 h-12 text-gray-400 mx-auto mb-4" />
            <p className="text-gray-600">No tienes negocios creados aún</p>
            <button
              onClick={() => navigate('/create-business-1')}
              className="mt-4 text-blue-600 hover:text-blue-700"
            >
              Crear mi primer negocio
            </button>
          </div>
        ) : (
          <>
            <div className="grid gap-4">
              {businesses.map(business => (
                <div
                  key={business.id}
                  className="bg-white p-4 rounded-lg shadow-sm"
                >
                  <div className="flex items-start justify-between">
                    <div>
                      <h3 className="font-medium text-lg">{business.name}</h3>
                      <p className="text-gray-500 text-sm">{business.description}</p>
                      <p className="text-xs text-gray-400 mt-2">
                        Creado el {new Date(business.created_at).toLocaleDateString()}
                      </p>
                    </div>
                    {business.id === user.business_id && (
                      <span className="px-2 py-1 bg-blue-100 text-blue-700 text-xs rounded-full">
                        Activo
                      </span>
                    )}
                  </div>
                </div>
              ))}
            </div>

            <button
              onClick={() => navigate('/create-business-1')}
              className="w-full mt-4 flex items-center justify-center gap-2 py-2 px-4 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
            >
              <Building2 className="w-4 h-4" />
              Crear otro negocio
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default BusinessList; 